var map = {
	"./england/AFC_Bournemouth.svg": 215,
	"./england/Arsenal_FC.svg": 7377,
	"./england/Aston_Villa_FC.svg": 9282,
	"./england/Brighton_&_Hove_Albion.svg": 7744,
	"./england/Burnley_FC.svg": 96,
	"./england/Chelsea_FC.svg": 4406,
	"./england/Crystal_Palace_FC.svg": 5295,
	"./england/Everton_FC.svg": 368,
	"./england/FC_Southampton.svg": 2896,
	"./england/Leicester_City.svg": 6364,
	"./england/Liverpool_FC.svg": 9296,
	"./england/Manchester_City_FC.svg": 7060,
	"./england/Manchester_United_FC.svg": 7315,
	"./england/Newcastle_United.svg": 743,
	"./england/Norwich_City.svg": 3539,
	"./england/Sheffield_United_FC.svg": 6766,
	"./england/Tottenham_Hotspur.svg": 4597,
	"./england/Watford.svg": 514,
	"./england/West_Ham_United_FC.svg": 6955,
	"./england/Wolverhampton_Wanderers.svg": 2162,
	"./france/AS_Monaco_FC.svg": 7518,
	"./france/AS_Saint-Etienne.svg": 8582,
	"./france/Amiens_SC.svg": 1420,
	"./france/Angers_SCO.svg": 8742,
	"./france/Dijon_FCO.svg": 1422,
	"./france/FC_Girondins_de_Bordeaux.svg": 7087,
	"./france/FC_Metz.svg": 270,
	"./france/FC_Nantes.svg": 4509,
	"./france/Lille_OSC.svg": 2769,
	"./france/Montpellier_HSC.svg": 5394,
	"./france/Nimes_Olympique.svg": 636,
	"./france/OGC_Nice.svg": 5860,
	"./france/Olympique_Lyonnais.svg": 2001,
	"./france/Olympique_Marseille.svg": 3789,
	"./france/Paris_Saint-Germain.svg": 3687,
	"./france/Racing_Club_de_Strasbourg.svg": 7711,
	"./france/Stade_Brestois_29.svg": 9737,
	"./france/Stade_Rennais_FC.svg": 8662,
	"./france/Stade_de_Reims.svg": 8561,
	"./france/Toulouse_FC.svg": 5149,
	"./germany/Bayer_04_Leverkusen.svg": 7036,
	"./germany/Borussia_Dortmund.svg": 6249,
	"./germany/Borussia_Mönchengladbach.svg": 2601,
	"./germany/Eintracht_Frankfurt.svg": 6233,
	"./germany/FC_Augsburg.svg": 6878,
	"./germany/FC_Bayern_München.svg": 9106,
	"./germany/FC_Cologne.svg": 2477,
	"./germany/FC_Schalke_04.svg": 1763,
	"./germany/FC_Union_Berlin.svg": 9600,
	"./germany/Fortuna_Düsseldorf.svg": 9700,
	"./germany/Hertha_BSC.svg": 2763,
	"./germany/Mainz_05.svg": 9581,
	"./germany/RB_Leipzig.svg": 7689,
	"./germany/SC_Freiburg.svg": 9003,
	"./germany/SC_Paderborn_07.svg": 1857,
	"./germany/SV_Werder_Bremen.svg": 271,
	"./germany/TSG_Hoffenheim.svg": 1982,
	"./germany/VfL_Wolfsburg.svg": 2247,
	"./italy/ACF_Fiorentina.svg": 154,
	"./italy/AC_Milan.svg": 1714,
	"./italy/AS_Roma.svg": 2329,
	"./italy/Atalanta.svg": 9963,
	"./italy/Bologna.png": 655,
	"./italy/Brescia.svg": 3282,
	"./italy/Cagliari.svg": 7603,
	"./italy/Genoa.png": 1970,
	"./italy/Hellas_Verona_FC.svg": 681,
	"./italy/Inter_Milan.png": 7181,
	"./italy/Juventus_FC.svg": 3105,
	"./italy/Parma.png": 8115,
	"./italy/S.S.C._Napoli.svg": 4151,
	"./italy/SPAL.svg": 3123,
	"./italy/SS_Lazio.svg": 1543,
	"./italy/Torino_FC.svg": 5413,
	"./italy/U.C._Sampdoria.svg": 7095,
	"./italy/US_Lecce.svg": 3416,
	"./italy/US_Sassuolo_Calcio.svg": 5939,
	"./italy/Udinese.png": 8058,
	"./spain/Atletico_Madrid.svg": 1759,
	"./spain/Club_Athletic_Bilbao.svg": 114,
	"./spain/Deportivo_Alaves.svg": 8788,
	"./spain/FC_Barcelona.svg": 3058,
	"./spain/Getafe_CF.svg": 2816,
	"./spain/Granada_CF.svg": 39,
	"./spain/Leganes.svg": 554,
	"./spain/Levante_UD.svg": 1056,
	"./spain/Osasuna.svg": 9805,
	"./spain/RCD_Espanyol.svg": 4228,
	"./spain/RCD_Mallorca.svg": 2112,
	"./spain/RC_Celta_de_Vigo.svg": 6576,
	"./spain/Real_Betis.svg": 235,
	"./spain/Real_Madrid_CF.svg": 4708,
	"./spain/Real_Sociedad.svg": 7062,
	"./spain/Real_Valladolid.svg": 5449,
	"./spain/SD_Eibar.svg": 9586,
	"./spain/Sevilla_FC.png": 8516,
	"./spain/Valencia_CF.svg": 7745,
	"./spain/Villarreal_CF.svg": 5846
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3709;